import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import React, {useState} from "react";

const IjaraAdd = ({ showModal, onHide, setShowModal, selectedItem, formData, setFormData, handleTransportInput, selectTransport,
                      filteredTransports, handleEditSave, handleAddSave, setShowCombo, showCombo, transportId}) => {
    // const [showCombo, setShowCombo] = useState(false);

    return (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered style={{zIndex: 2000}}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {selectedItem ? 'Ijarani tahrirlash' : 'Yangi ijara qo‘shish'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {!transportId && (
                        <Form.Group className="mb-3" style={{position: 'relative'}}>
                            <Form.Label>Transport raqami</Form.Label>
                            <Form.Control
                                type="text"
                                autoComplete="off"
                                value={formData.transportNumber}
                                onChange={handleTransportInput}
                                placeholder="Masalan: 01 A 234 BC"
                                onFocus={() => setShowCombo(true)}
                            />
                            {showCombo && filteredTransports.length > 0 && (
                                <div
                                    className="border bg-white position-absolute w-100 shadow-sm"
                                    style={{zIndex: 10, maxHeight: '180px', overflowY: 'auto'}}
                                >
                                    {filteredTransports.map((t) => {
                                        const isSelected = t.davlat_raqam === formData.transportNumber;
                                        return (
                                            <div
                                                key={t.id}
                                                className={`px-2 py-1 selectable-item ${isSelected ? 'selected' : ''}`}
                                                onClick={() => selectTransport(t.davlat_raqam, t.id)}
                                            >
                                                {t.davlat_raqam}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </Form.Group>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label>Ijara raqami</Form.Label>
                        <Form.Control
                            type="text"
                            value={formData.raqam}
                            onChange={(e) =>
                                setFormData({...formData, raqam: e.target.value})
                            }
                            placeholder="Masalan: IJ-0001"
                        />
                    </Form.Group>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>Boshlanish sanasi</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formData.dan}
                                    onChange={(e) =>
                                        setFormData({...formData, dan: e.target.value})
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>Tugash sanasi</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formData.gacha}
                                    onChange={(e) =>
                                        setFormData({...formData, gacha: e.target.value})
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <Form.Label>Izoh</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            value={formData.izoh}
                            onChange={(e) =>
                                setFormData({...formData, izoh: e.target.value})
                            }
                            placeholder="Izoh kiriting..."
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Ijara Faylini tanlash</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={(e) =>
                                setFormData({...formData, fayl: e.target.files[0]})
                            }
                        />
                    </Form.Group>
                    <div className="text-end">
                        <Button variant="secondary" onClick={() => {
                            setShowModal(false);
                            setShowCombo(false);
                        }} className="me-2">
                            Bekor qilish
                        </Button>
                        <Button variant="primary" onClick={selectedItem ? handleEditSave : handleAddSave}>
                            Saqlash
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    )
}

export default IjaraAdd;